import { Popover, type PopoverProps } from '@affine/component';
import type { RefObject } from 'react';

import { STREAMLAIN_DROPDOWN_MENU_OFFSET } from './chrome';
import { RadixDropdownPanelChrome } from './radix-chrome';

export type StreamLainPopoverProps = PopoverProps & {
  triggerRef: RefObject<HTMLElement | null>;
};

/** Popover with the shared StreamLain disclosure chrome. */
export function StreamLainPopover({
  content,
  contentOptions,
  triggerRef,
  ...props
}: StreamLainPopoverProps) {
  return (
    <Popover
      {...props}
      contentOptions={{
        collisionPadding: 8,
        sideOffset: STREAMLAIN_DROPDOWN_MENU_OFFSET,
        ...contentOptions,
      }}
      content={
        <RadixDropdownPanelChrome triggerRef={triggerRef}>
          {content}
        </RadixDropdownPanelChrome>
      }
    />
  );
}
